<template lang="html">
    <a :href="file" download="NombreDelArchivoDescargado.pdf" target="_blank" class="adownload">
    <button class="btn-download" @click="descargarPdf">
        <span class="icon-download">
            <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.86207 22.3158H21.931C22.1597 22.3158 22.3789 22.4045 22.5406 22.5624C22.7023 22.7203 22.7931 22.9345 22.7931 23.1579C22.7931 23.3812 22.7023 23.5954 22.5406 23.7533C22.3789 23.9113 22.1597 24 21.931 24H9.86207C9.63343 24 9.41416 23.9113 9.25249 23.7533C9.09083 23.5954 9 23.3812 9 23.1579C9 22.9345 9.09083 22.7203 9.25249 22.5624C9.41416 22.4045 9.63343 22.3158 9.86207 22.3158ZM16.7586 17.4105L19.5543 14.6804L20.7733 15.8711L15.8966 20.6349L11.0198 15.8711L12.2388 14.6804L15.0345 17.4105V7.99998H16.7586V17.4105Z"
                    fill="url(#paint0_radial_164_221)"
                    fill-opacity="0.97"
                />
                <defs>
                    <radialGradient
                        id="paint0_radial_164_221"
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(15.8966 12.96) rotate(90) scale(11.04 9.51724)"
                    >
                        <stop stop-color="#33647E" />
                        <stop offset="1" stop-color="#013652" />
                    </radialGradient>
                </defs>
            </svg>
        </span>
        <span class="text">{{ text }}</span>
    </button>
    </a>
</template>
<script>

import axios from "axios";
import { saveAs } from "file-saver";
export default {
    props: {
        text: String,
        file: String,    
    },
    methods: {
    descargarPdf() {
      const url = this.file;
      console.log({url})
      axios({
    url,
    method: "GET",
    responseType: "blob", // Importante para manejar el stream de datos del PDF
  })
    .then((response) => {
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      saveAs(pdfBlob, "archivo_descargado.pdf");
    })
    .catch((error) => console.error("Error al descargar el archivo:", error));
    }
  }
}
</script>
<style lang="css" scoped>
.btn-download {
    background: #ffffff;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    border: none;
    outline: none;
    padding: 6px;
    padding-right: 14px;
    max-width: 220px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}
.btn-download .icon-download {
    margin-right: 6px;
}
.btn-download .text {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #696f72;
    text-align: left;
}
.btn-download:hover .text {
    color: rgba(1, 54, 82, 0.8);
}
.adownload {
    text-decoration: none;
}
</style>